import { render, staticRenderFns } from "./DeleteRedundantPhotosDialog.vue?vue&type=template&id=f985354e&scoped=true"
import script from "./DeleteRedundantPhotosDialog.vue?vue&type=script&lang=js"
export * from "./DeleteRedundantPhotosDialog.vue?vue&type=script&lang=js"
import style0 from "./DeleteRedundantPhotosDialog.vue?vue&type=style&index=0&id=f985354e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f985354e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f985354e')) {
      api.createRecord('f985354e', component.options)
    } else {
      api.reload('f985354e', component.options)
    }
    module.hot.accept("./DeleteRedundantPhotosDialog.vue?vue&type=template&id=f985354e&scoped=true", function () {
      api.rerender('f985354e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/other/DeleteRedundantPhotosDialog.vue"
export default component.exports